import { Button } from '$components/Button';
import { TabItem } from '$components/TabsZero/TabItem';
import cn from 'classnames';
import React, { PropsWithChildren, useState } from 'react';

const sourceToListTitle = {
  newsroom: 'Newsroom',
};

export function ListContent(
  props: PropsWithChildren<{
    setFilter: (filter: string) => void;
    more: () => void;
    hasNextPage: boolean;
    source: string;
  }>,
) {
  const {
    source,
    setFilter = () => {},
    more = () => {},
    children,
    hasNextPage = false,
  } = props;

  const [activeTabIndex, setActiveTabIndex] = useState(0);

  return (
    <section>
      <div className="flex flex-row justify-center">
        <div className={`grid-standard `}>
          <div className={'col-span-4 lg:col-span-12'}>
            {sourceToListTitle[source] && (
              <h1 className={cn('style-heading-s capitalize text-center mb-8')}>
                {sourceToListTitle[source]}
              </h1>
            )}
            <div className={cn('flex space-x-8 justify-center mb-10 md:mb-16')}>
              <TabItem
                type={'light'}
                key={'all'}
                title={'All'}
                index={0}
                active={activeTabIndex === 0}
                onClick={() => {
                  setFilter('all');
                  setActiveTabIndex(0);
                }}
                content={null}
              />
              <TabItem
                type={'light'}
                key={'press'}
                title={'Press'}
                index={2}
                active={activeTabIndex === 2}
                onClick={() => {
                  setFilter('press');
                  setActiveTabIndex(2);
                }}
                content={null}
              />
              <TabItem
                type={'light'}
                key={'news'}
                title={'News'}
                index={1}
                active={activeTabIndex === 1}
                onClick={() => {
                  setFilter('news');
                  setActiveTabIndex(1);
                }}
                content={null}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-row justify-center min-h-[672px]">
        <div className={`grid-standard `}>
          {React.Children.map(children, (child, i) => {
            if (child === null) return; // This would be the case if URL returns null in the parent
            return (
              <div
                key={i}
                className={`col-span-4 md:col-span-2 lg:col-span-6 l:col-span-4`}
              >
                {child}
              </div>
            );
          })}
        </div>
      </div>
      {hasNextPage && (
        <div className="flex flex-row justify-center">
          <div className={`grid-standard`}>
            <div
              className={`col-span-4 lg:col-span-12 items-center justify-center flex pt-16`}
            >
              <Button action={more} kind="secondary">
                Load more
              </Button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
